import {$, HttpBody, HttpIgnore, ID, RequestExclude, Resource, ResponseSerialize} from 'simpli-web-sdk'
import ConfigNovaSlaSchema from '@/schema/ConfigNovaSla.schema'
import Responsavel from '@/model/resource/Responsavel'
import CalendarizacaoSla from '@/model/resource/CalendarizacaoSla'
import {Exclude} from 'class-transformer'

export default class ConfigNovaSla extends Resource {
  static async showOldSla(spinner = 'getShowOldSla') {
    const fetch = () => new HttpBody(Boolean).GET(`/user/config-nova-sla/show-old-sla`)
    return await $.await.run(fetch, spinner)
  }

  static async showOrigem(spinner = 'getShowOrigem') {
    const fetch = () => new HttpBody(Boolean).GET(`/user/config-nova-sla/show-origem`)
    return await $.await.run(fetch, spinner)
  }

  static async slaType(spinner = 'getSlaType') {
    const fetch = () => new HttpBody<number>().GET(`/user/config-nova-sla/sla-type`)
    return await $.await.run(fetch, spinner)
  }

  get $schema() {
    return ConfigNovaSlaSchema(this)
  }

  get $id() {
    return this.idConfigNovaSlaPk
  }
  set $id(val: ID) {
    this.idConfigNovaSlaPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  @Exclude()
  readonly $name: string = 'ConfigNovaSla'

  @Exclude()
  readonly $endpoint: string = '/user/config-nova-sla'

  @Exclude()
  idConfigNovaSlaPk: ID = 0

  ufOrigem: string | null = null

  ufDestino: string | null = null

  cidadeOrigem: string | null = null

  cidadeDestino: string | null = null

  sla: number | null = null

  @Exclude()
  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  cnpjEmbarcador: string | null = null

  cnpjTransportador: string | null = null

  @ResponseSerialize(CalendarizacaoSla)
  calendarizacao: CalendarizacaoSla | null = null

  @Exclude()
  calendarizacaoString: string | null = null

}
